// dpc-email-login.js — Login por código de 6 dígitos vía email (alternativa a Google Sign-In)
// Subir como theme asset en Shopify y cargar desde PEGAR-EN-SHOPIFY.liquid con:
//   <script src="{{ 'dpc-email-login.js' | asset_url }}" defer></script>
// Depende de globales del app principal: loggedIn, user, persistUser, perfil, fetchUserOrders

(function () {
  'use strict';

  const API = 'https://drinking-partners-calendar-app.fly.dev/api/auth/email-code';
  const TTL_RESEND_MS = 30000; // cooldown antes de poder reenviar

  // Estado interno del componente
  const state = {
    step: 'email',  // 'email' o 'code'
    email: '',
    error: '',
    resendAt: 0,
    intervalId: null,
    loading: false,
  };

  function resetState() {
    if (state.intervalId) { clearInterval(state.intervalId); state.intervalId = null; }
    state.step = 'email';
    state.email = '';
    state.error = '';
    state.resendAt = 0;
    state.loading = false;
  }

  function emailValid(e) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
  }

  function htmlEmail() {
    const err = state.error
      ? `<div style="color:#ff6b6b;font-size:12px;margin-top:8px;text-align:center">${state.error}</div>`
      : '';
    return `
      <div style="font-size:12px;color:#777;margin-bottom:10px;letter-spacing:0.3px">— o entra con tu email —</div>
      <input id="dpc-em-input" type="email" placeholder="tu@email.com"
        autocomplete="email" inputmode="email" autocapitalize="none" autocorrect="off"
        style="width:100%;background:#1a1a1a;border:1px solid #333;color:#fff;font-size:14px;padding:11px 14px;border-radius:10px;outline:none;box-sizing:border-box;-webkit-appearance:none">
      <button id="dpc-em-send"
        style="width:100%;margin-top:8px;background:#FF914D;border:none;color:#fff;font-size:14px;font-weight:600;padding:11px;border-radius:10px;cursor:pointer">
        ${state.loading ? 'Enviando…' : 'Enviar código'}
      </button>
      ${err}
    `;
  }

  function htmlCode() {
    const secs = Math.max(0, Math.ceil((state.resendAt - Date.now()) / 1000));
    const err = state.error
      ? `<div style="color:#ff6b6b;font-size:12px;margin-top:8px;text-align:center">${state.error}</div>`
      : '';
    return `
      <div style="font-size:13px;color:#aaa;margin-bottom:4px">Código enviado a</div>
      <div style="font-size:13px;color:#fff;font-weight:600;margin-bottom:14px;word-break:break-all">${state.email}</div>
      <input id="dpc-em-code" type="text"
        inputmode="numeric" autocomplete="one-time-code" pattern="\\d{6}" maxlength="6"
        placeholder="000000"
        style="width:100%;background:#1a1a1a;border:1px solid #333;color:#fff;font-size:22px;font-weight:700;letter-spacing:8px;text-align:center;padding:14px;border-radius:10px;outline:none;box-sizing:border-box;font-family:'SF Mono','Monaco','Consolas',monospace">
      <button id="dpc-em-verify"
        style="width:100%;margin-top:8px;background:#FF914D;border:none;color:#fff;font-size:14px;font-weight:600;padding:11px;border-radius:10px;cursor:pointer">
        ${state.loading ? 'Verificando…' : 'Verificar'}
      </button>
      ${err}
      <div style="display:flex;justify-content:space-between;align-items:center;margin-top:14px;font-size:12px">
        <button id="dpc-em-back"
          style="background:none;border:none;color:#888;cursor:pointer;padding:4px 0;font-size:12px">
          ← Cambiar email
        </button>
        <button id="dpc-em-resend" ${secs > 0 ? 'disabled' : ''}
          style="background:none;border:none;color:${secs > 0 ? '#555' : '#FF914D'};cursor:${secs > 0 ? 'default' : 'pointer'};padding:4px 0;font-size:12px;font-weight:600">
          ${secs > 0 ? `Reenviar (${secs}s)` : 'Reenviar código'}
        </button>
      </div>
    `;
  }

  function render() {
    const mount = document.getElementById('dpcEmailMount');
    if (!mount) return; // se llamará de nuevo cuando perfil() lo renderice

    if (state.step === 'email') {
      mount.innerHTML = htmlEmail();
      bindEmail(mount);
      setTimeout(() => { const i = mount.querySelector('#dpc-em-input'); if (i) i.focus(); }, 60);
    } else {
      mount.innerHTML = htmlCode();
      bindCode(mount);
      setTimeout(() => { const i = mount.querySelector('#dpc-em-code'); if (i) i.focus(); }, 60);
    }
  }

  function bindEmail(mount) {
    const input = mount.querySelector('#dpc-em-input');
    const btn = mount.querySelector('#dpc-em-send');
    if (input) {
      // restaurar lo último que tipeó si vuelve
      if (state.email) input.value = state.email;
      input.addEventListener('keydown', (ev) => {
        if (ev.key === 'Enter') { ev.preventDefault(); requestCode(input.value); }
      });
    }
    if (btn) btn.addEventListener('click', () => requestCode(input ? input.value : ''));
  }

  function bindCode(mount) {
    const input = mount.querySelector('#dpc-em-code');
    const btn = mount.querySelector('#dpc-em-verify');
    const back = mount.querySelector('#dpc-em-back');
    const resend = mount.querySelector('#dpc-em-resend');
    if (input) {
      input.addEventListener('input', (ev) => {
        const v = ev.target.value.replace(/\D/g, '').slice(0, 6);
        if (v !== ev.target.value) ev.target.value = v;
        if (v.length === 6) verifyCode(v);
      });
      input.addEventListener('keydown', (ev) => {
        if (ev.key === 'Enter') { ev.preventDefault(); verifyCode(input.value); }
      });
    }
    if (btn) btn.addEventListener('click', () => verifyCode(input ? input.value : ''));
    if (back) back.addEventListener('click', () => {
      if (state.intervalId) { clearInterval(state.intervalId); state.intervalId = null; }
      state.step = 'email';
      state.error = '';
      render();
    });
    if (resend) resend.addEventListener('click', () => {
      if (Date.now() < state.resendAt) return;
      requestCode(state.email);
    });
  }

  async function requestCode(emailRaw) {
    const email = (emailRaw || '').trim().toLowerCase();
    if (!emailValid(email)) {
      state.error = 'Ingresa un email válido';
      render();
      return;
    }
    state.error = '';
    state.loading = true;
    render();
    try {
      const res = await fetch(API + '/request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      state.loading = false;
      if (res.status === 429) {
        const d = await res.json().catch(() => ({}));
        state.error = d.error || 'Demasiados intentos. Espera unos minutos.';
        render();
        return;
      }
      if (!res.ok) {
        state.error = 'No pudimos enviar el código. Intenta de nuevo.';
        render();
        return;
      }
      state.email = email;
      state.step = 'code';
      state.resendAt = Date.now() + TTL_RESEND_MS;
      if (state.intervalId) clearInterval(state.intervalId);
      state.intervalId = setInterval(() => {
        if (Date.now() >= state.resendAt) {
          clearInterval(state.intervalId);
          state.intervalId = null;
        }
        render();
      }, 1000);
      render();
    } catch (e) {
      state.loading = false;
      state.error = 'Error de conexión';
      render();
    }
  }

  async function verifyCode(codeRaw) {
    const code = (codeRaw || '').trim();
    if (!/^\d{6}$/.test(code)) {
      state.error = 'El código son 6 dígitos';
      render();
      return;
    }
    state.error = '';
    state.loading = true;
    render();
    try {
      const res = await fetch(API + '/verify', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: state.email, code }),
      });
      const data = await res.json().catch(() => ({}));
      state.loading = false;

      if (data && data.ok && data.jwt && data.user) {
        // Setear sesión con el mismo shape que Google Sign-In del app principal
        try {
          if (typeof window.loggedIn !== 'undefined') window.loggedIn = true;
        } catch (e) {}

        const u = {
          name: data.user.name || state.email.split('@')[0],
          email: data.user.email,
          picture: null,
          sub: 'email:' + data.user.email,
          token: data.jwt,
          authMethod: 'email_code',
          loginAt: Date.now(),
          reservas: [],
          historial: [],
        };

        // Las variables loggedIn/user son del scope del app principal.
        // Usamos un eval-helper expuesto por el app para setearlas correctamente.
        // Como fallback, despachamos un evento que el app principal escucha.
        if (typeof window.dpcSetSession === 'function') {
          window.dpcSetSession(u);
        } else {
          // Fallback: asignar directo si están en window
          window.loggedIn = true;
          window.user = u;
          if (typeof window.persistUser === 'function') window.persistUser();
          if (typeof window.perfil === 'function') window.perfil();
          if (typeof window.fetchUserOrders === 'function') window.fetchUserOrders(true);
        }

        resetState();
        return;
      }

      // Errores conocidos
      const motivo = data && data.motivo;
      if (motivo === 'wrong_code') {
        const left = typeof data.intentos_restantes === 'number' ? data.intentos_restantes : null;
        state.error = left !== null
          ? `Código incorrecto. Te quedan ${left} intento${left === 1 ? '' : 's'}.`
          : 'Código incorrecto.';
      } else if (motivo === 'expired') {
        state.error = 'El código expiró. Pide uno nuevo.';
      } else if (motivo === 'locked_out') {
        state.error = 'Demasiados intentos. Pide un código nuevo.';
      } else if (motivo === 'no_active_code') {
        state.error = 'No hay código activo. Pide uno nuevo.';
      } else if (motivo === 'invalid_input') {
        state.error = 'Formato incorrecto.';
      } else {
        state.error = 'No pudimos verificar el código. Intenta de nuevo.';
      }
      // Si quedó bloqueado o expirado, limpiar el código pero quedar en step 'code' para que pida reenvío
      render();
    } catch (e) {
      state.loading = false;
      state.error = 'Error de conexión';
      render();
    }
  }

  // ============================================================
  // API pública: llamada desde perfil() del app principal
  // ============================================================
  window.dpcEmailInit = function () {
    // Re-render cuando perfil() pinta la pantalla de login
    render();
  };

  // Si el mount existe al momento de cargar (DOM ya listo), renderizar de una
  if (document.readyState !== 'loading') {
    if (document.getElementById('dpcEmailMount')) render();
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      if (document.getElementById('dpcEmailMount')) render();
    });
  }
})();
